import React from "react";
import styles from "../stylesER.module.scss";

export const AgencyCommissionModal = ({
  isOpen,
  monthIndex,
  mesesCompletos,
  comisiones,
  oportunidades,
  formatCurrency,
  pais,
  onClose,
}) => {
  if (!isOpen || monthIndex === null) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h3>Comisión agencias - {mesesCompletos[monthIndex]}</h3>
        <table className={styles.modalTable}>
          <thead>
            <tr>
              <th className={styles.agencyFacturaHeader}>Factura</th>
              <th className={styles.agencyClienteHeader}>Cliente</th>
              <th className={styles.agencyIntermediarioHeader}>Intermediario</th>
              <th className={styles.agencyImporteHeader}>Importe</th>
              <th className={styles.agencyPorcentajeHeader}>%</th>
              <th className={styles.agencyComisionHeader}>Comisión</th>
            </tr>
          </thead>
          <tbody>
            {comisiones.map((c, i) => (
              <tr key={i}>
                <td className={styles.agencyFacturaData}>{c.facturanumero}</td>
                <td className={styles.agencyClienteData}>
                  {oportunidades.find((o) => o.facturanumero === c.facturanumero)?.cliente || "—"}
                </td>
                <td className={styles.agencyIntermediarioData}>{c.intermediario}</td>
                <td className={styles.agencyImporteData}>
                  {c.moneda_dolar
                    ? `US$ ${(c.importeOriginalMoneda || 0).toLocaleString(pais === "Chile" ? "es-CL" : "es-PE", { maximumFractionDigits: 0 })}`
                    : formatCurrency(c.importe)}
                </td>
                <td className={styles.agencyPorcentajeData}>{c.porcentaje}%</td>
                <td className={styles.agencyComisionData}>{formatCurrency(c.comision)}</td>
              </tr>
            ))}
            {comisiones.length > 0 && (
              <tr className={styles.modalTotal}>
                <td colSpan="5">
                  <strong>Total</strong>
                </td>
                <td className={styles.agencyComisionData}>
                  <strong>{formatCurrency(comisiones.reduce((s, c) => s + c.comision, 0))}</strong>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className={styles.modalActions}>
          <button className={styles.btnClose} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};
